import { Callout } from '@tallink/components-lib'
import PropTypes from 'prop-types'
import React from 'react'
import { useTranslation } from 'react-i18next'

export default function UnsuccessfulPaymentCallout({ title }) {
  const { t } = useTranslation()

  return (
    <Callout
      body={t('payment.unsuccessful.description')}
      summary={<p dangerouslySetInnerHTML={{ __html: t('payment.unsuccessful.callCenter') }} />}
      title={title}
      type="error"
    />
  )
}

UnsuccessfulPaymentCallout.propTypes = {
  title: PropTypes.string.isRequired
}
